import { BaseToolbarProps } from './BaseToolbar.types';
import { styles } from './BaseToolbarMobile.styles';
import React, { forwardRef, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useBaseToolbarLogic } from './BaseToolbar.logic';
import { useOnClickOutside } from 'src/hooks/useOnClickOutside';
import { ScrollView, useWindowDimensions, View } from 'react-native';
import { ToolbarTileMobile } from './toolbar-tile/ToolbarTileMobile';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { configurationTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { ToolbarButtonMobile } from './toolbar-tile/ToolbarButtonMobile';

const DEFAULT_MARGIN_LEFT = 16;

export const BaseToolbarMobile = observer(
  forwardRef((props: BaseToolbarProps & { isLookup?: boolean }, ref?: any) => {
    const { isLookup, isEdit } = props;
    const BaseToolbarRef = ref || useRef(null);
    const { tiles, onClose, onDelete } = useBaseToolbarLogic(props);

    const [centeredItems, setCenteredItems] = useState<boolean>(true);
    const { width: windowWidth } = useWindowDimensions();

    useOnClickOutside(BaseToolbarRef, onClose);

    return (
      <View style={{ alignItems: centeredItems ? 'center' : 'flex-start' }}>
        <ScrollView
          ref={BaseToolbarRef}
          onLayout={e => setCenteredItems(e.nativeEvent.layout.x > DEFAULT_MARGIN_LEFT)}
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={[styles.listContainer, { maxWidth: windowWidth }]}
        >
          {tiles.map((tile, index) => (
            <ToolbarTileMobile
              key={`Tool-tile-${tile.tool.code}-${tile.tool.titleKey}`}
              {...tile}
              style={{ marginLeft: index === 0 && !centeredItems ? DEFAULT_MARGIN_LEFT : 0 }}
              isLookup={isLookup}
            />
          ))}
          {!isEdit && (
            <ToolbarButtonMobile
              iconName={ICON_NAMES.Delete}
              text={'group-action-bar-v3:delete-selected'}
              testID={configurationTestID(TestIDs.DELETE_SELECTED)}
              focusId={configurationTestID(TestIDs.DELETE_SELECTED)}
              focusOrder={tiles.length + 2}
              focusGroup={FocusGroups.TOOLBAR_TILES}
              onPress={async () => onDelete()}
            />
          )}
        </ScrollView>
      </View>
    );
  }),
);

BaseToolbarMobile.displayName = 'BaseToolbar';
